import { QueryClient } from "@tanstack/react-query";
import { typeWireOf } from "@typewirets/core";

export const QueryClientWire = typeWireOf({
  token: "QueryClient",
  creator() {
    return new QueryClient({
      defaultOptions: {
        queries: {
          retry: false,
          refetchOnWindowFocus: true,
        },
      },
    });
  },
});
